module.exports = __webpack_public_path__ + "static/img/rczp.7d7ca75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jianjie/rczp.png
// module id = BOSs
// module chunks = 171